import type { GenieKnowledgeEntry } from '../../types';

export const smallFiberNeuropathy: GenieKnowledgeEntry = {
  id: 'small_fiber_neuropathy',
  name: 'Neuropatía de Fibras Delgadas',
  category: 'neuropatico',
  conversation: {
    headline:
      'NCS de rutina NORMALES — no evalúan fibras Aδ/C. Dolor quemante con propiocepción conservada.',
    edxHighlights: [
      'CMAP y SNAP normales en NCS convencionales',
      'QSART anormal en 50–80% de casos',
      'Biopsia de piel (IENFD): gold standard diagnóstico',
      'Umbrales QST de frío/calor-dolor elevados',
    ],
    pearls: [
      'No descartar neuropatía solo porque las NCS son normales.',
      'Pre-diabetes/intolerancia a glucosa: causa subdiagnosticada — considerar CTGO.',
    ],
    differentials: [
      { name: 'Polineuropatía axonal', distinguishingHint: 'SNAPs distales reducidos en NCS' },
      { name: 'Fibromialgia', distinguishingHint: 'sin disautonomía ni IENFD reducida' },
    ],
    nextSteps: [
      'Biopsia de piel si dolor neuropático severo con NCS normal',
      'Evaluar glucosa, CTGO, autoinmunes (Sjögren)',
    ],
  },
  orientationHints: {
    temporalFit: ['chronic'],
    whenToSuspect: 'Dolor quemante distal + NCS normales + termoalgésia alterada',
  },
};
